'use client';
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

interface Props {
  data: { month: string; retail: number; l1Bonus: number; eb: number; eeb: number; dblg1: number; breakaway: number }[];
}

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  const total = payload.reduce((s: number, p: any) => s + (p.value || 0), 0);
  return (
    <div className="bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2 shadow-xl">
      <p className="text-xs font-semibold text-zinc-300 mb-1.5">{label}</p>
      {payload.map((p: any) => (
        <div key={`ctt-${p.dataKey}`} className="flex justify-between gap-4 text-xs">
          <span style={{ color: p.color }}>{p.name}</span>
          <span className="font-mono text-zinc-200">${(p.value / 1000).toFixed(1)}K</span>
        </div>
      ))}
      <div className="border-t border-zinc-700 mt-1.5 pt-1.5 flex justify-between text-xs">
        <span className="text-zinc-400">Total</span>
        <span className="font-mono font-bold text-emerald-400">${(total / 1000).toFixed(1)}K</span>
      </div>
    </div>
  );
};

export default function CommissionComponentChart({ data }: Props) {
  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-zinc-300">Commission by Component — 12 Months</h3>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={data} margin={{ top: 4, right: 4, left: -15, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" vertical={false} />
          <XAxis dataKey="month" tick={{ fontSize: 10, fill: '#71717a' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 9, fill: '#71717a' }} axisLine={false} tickLine={false} tickFormatter={v => `$${(v / 1000).toFixed(0)}K`} />
          <Tooltip content={<CustomTooltip />} />
          <Legend iconSize={8} iconType="square" wrapperStyle={{ fontSize: '10px', paddingTop: '6px' }} />
          <Bar dataKey="retail" name="Retail" stackId="a" fill="#34d399" />
          <Bar dataKey="l1Bonus" name="L1" stackId="a" fill="#60a5fa" />
          <Bar dataKey="eb" name="EB" stackId="a" fill="#a78bfa" />
          <Bar dataKey="eeb" name="EEB" stackId="a" fill="#c084fc" />
          <Bar dataKey="dblg1" name="DBLG1" stackId="a" fill="#fbbf24" />
          <Bar dataKey="breakaway" name="Breakaway" stackId="a" fill="#f87171" radius={[2, 2, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}